module.exports = __webpack_public_path__ + "img/marker-oil-transport-red.12b2cb58.png";